import api from "./index";

export interface MedicalCondition {
  id: string;
  name: string;
  createdAt: string;
  updatedAt: string;
}

export interface MedicalConditionCreateUpdatePayload {
  id?: string;
  name: string;
}

export const getMedicalConditions = async (): Promise<{
  data: MedicalCondition[];
}> => {
  const response = await api.get("/medical-condition/getAll");
  return response.data;
};

export const createOrUpdateMedicalCondition = async (
  payload: MedicalConditionCreateUpdatePayload
) => {
  return api.post("/medical-condition/create-update", payload);
};

export const deleteMedicalCondition = async (id: string) => {
  return api.get(`/medical-condition/delete/${id}`);
};

export const getMedicalConditionById = async (id: string) => {
  return api.get(`/medical-condition/getById/${id}`);
};